import { EMarketingClientPath } from '~/models/api'
import pathBuilder from '~/utils/api'

export const LIBBY_VIDEO_URL =
  'https://www.youtube-nocookie.com/embed/rft2FjNLn7c?si=E9iBfFjh2FPbfF9V?rel=0'
export const EXAMPLE_PAGE_PHONE_NUMBER = '1-469-629-7974'
export const MARKETING_SITE_ORIGIN = 'https://www.replify.ai'

export const DYNAMIC_MARKETING_PATHS = [EMarketingClientPath.referralLink]

const EXCLUDED_MARKETING_PATHS = [
  EMarketingClientPath.home,
  EMarketingClientPath.payments,
  EMarketingClientPath.loadingItem,
]

export const STATIC_MARKETING_PATHS = Object.values(
  EMarketingClientPath,
).filter(
  (path) =>
    !DYNAMIC_MARKETING_PATHS.includes(path) &&
    !EXCLUDED_MARKETING_PATHS.includes(path),
)

export const PARTIAL_DYNAMIC_MARKETING_PATHS = [
  pathBuilder(EMarketingClientPath.referralLink, { referralCode: '' }),
]
